/**
 * Ensures Lingui locale is set as early as possible on both server and client.
 * Import this once at app bootstrap so module-level t() calls are always safe.
 */
import { i18n } from '@lingui/core'
import {
  getDefaultMessagesSync,
  getMessagesFromCatalogModule
} from '@/utils/i18n'

const hasCatalogMessages = (messages?: Record<string, unknown>) =>
  Object.keys(messages ?? {}).length > 0

const loadDefaultEnglishCatalogInBrowser = async () => {
  try {
    const data = await import('@/../../translations/locales/en/messages.po')
    const messages = getMessagesFromCatalogModule(data)

    if (hasCatalogMessages(messages)) {
      i18n.loadAndActivate({ locale: 'en', messages })
    }
  } catch {
    // _app.tsx will still hydrate with route messages.
  }
}

if (!i18n.locale) {
  const isServer = typeof window === 'undefined'

  i18n.loadAndActivate({
    locale: 'en',
    messages: isServer ? getDefaultMessagesSync() : {}
  })

  if (!isServer) {
    void loadDefaultEnglishCatalogInBrowser()
  }
} else if (
  typeof window !== 'undefined' &&
  i18n.locale === 'en' &&
  !hasCatalogMessages(i18n.messages as Record<string, unknown>)
) {
  // Recover in case client already has en active but empty catalog.
  void loadDefaultEnglishCatalogInBrowser()
}
